
import { BrowserProductQueryQuery } from '@generated/graphql';
import React, { useMemo } from 'react' 
import { useProduct } from 'src/sdk/product/useProduct';
import InsiderBuyTogetherLoading from './InsiderBuyTogetherLoading';
import InsiderBuyTogetherDefaultProductCard from './InsiderBuyTogetherDefaultShelf/InsiderBuyTogetherDefaultProductCard';

interface Props {
  productId: string
  index: number
  defaultSelected?: boolean
}

const InsiderGraphQLProductCard: React.FC<Props> = ({
  productId,
  index,
  defaultSelected = true,
}) => {
  const { data, error, isValidating } = useProduct<BrowserProductQueryQuery>(productId);

  const productForCard = useMemo(() => {
    const originalProduct = data?.product;

    if (!originalProduct) {
      return null;
    }

    const adaptedProduct = {
      ...originalProduct,
      brand: {
        ...originalProduct.brand,
        brandName: originalProduct.brand.name,
      },
    };

    return adaptedProduct as any ;

  }, [data]); 

  if (isValidating && !data) {
    return <InsiderBuyTogetherLoading/>;
  }

  if (error || !productForCard) {
    console.error(`Falha ao carregar ou adaptar produto ${productId}:`, error);
    return null;
  }

  return (
    <InsiderBuyTogetherDefaultProductCard
      key={productForCard?.id}
      product={productForCard} 
      index={index}
      defaultSelected={defaultSelected}
    />
  );
};

export default InsiderGraphQLProductCard;